import { InstantiateExpr } from '@angular/compiler';
import { Component, effect, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiSelectComponent } from '@engie-group/fluid-design-system-angular';
import { AlertLevel, AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { ListItemData } from 'src/app/core/Dtos/list-item-data';
import { ResInstructionDTO, ResIntructionType } from 'src/app/core/Dtos/res/instructions-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { FhcHydroService } from 'src/app/core/services/fhc-hydro.service';
import { GeneralDataService } from 'src/app/core/services/general-data.service';
import { ResService } from 'src/app/core/services/res.service';

@Component({
  selector: 'app-res',
  templateUrl: './res.component.html',
  styleUrl: './res.component.scss',
  standalone: false
})
export class ResComponent {
  public Instruction: ResInstructionDTO = new ResInstructionDTO();
  // public BMUList: string[] = [];
  public ResIntructionType = ResIntructionType;

  public closeFileToUpload: File | null = null;
  public closeFileData: string = "";

  public coFileToUpload: File | null = null;
  public coFileData: string = "";

  @ViewChild(MultiSelectComponent)
  _selectedSettlements: MultiSelectComponent | undefined;

  BMUList: string[] = [
    "CREAW-1",
    "MOWEO-1",
    "MOWEO-2",
    "MOWEO-3",
    "MOWWO-1",
    "MOWWO-2",
    "MOWWO-3",
    "MOWWO-4",
    "SAKNW-1",
    "TEBWS-1"
  ];

  constructor(
    private _generalDataService: GeneralDataService,
    private _resService: ResService,
    private _router: Router,
    private _alertService: AlertsService,
    private _activatedRoute: ActivatedRoute,
    private _dateFormatHelper: DateFormatHelperService
  ) {

  }

  ngOnInit() {
    let id = this._activatedRoute.snapshot.paramMap.get("id");
    if (id !== null) {
        this.GetInstruction(parseInt(id));
      }
    else
      this.onStartDateChanged(null);
  }

  GetInstruction(id: number) {
    this._resService.GetInstructionById(id).subscribe(
      resp => {
        resp.issuedFrom = resp.issuedFrom.toString().split('T')[0];
        if (resp.issuedTo) {
          resp.issuedTo = resp.issuedTo.toString().split('T')[0];
        }
        this.Instruction = resp;
        if (resp.closeImage) {
          this.closeFileToUpload = this.base64ToFile(resp.closeImage, 'closeImage.png', 'image/png');
          this.closeFileData = URL.createObjectURL(this.closeFileToUpload);
        }

        if (resp.coAssumptionsImage) {
          this.coFileToUpload = this.base64ToFile(resp.coAssumptionsImage, 'coAssumptionsImage.png', 'image/png');
          this.coFileData = URL.createObjectURL(this.coFileToUpload);
        }
      }
    )
  }

  public SaveInstruction() {
  
    if ((this.Instruction.issuedFrom ?? "") == "") {
      this._alertService.ShowAlert(new AlertMessage(AlertLevel.Error, "Issued From date is required."));
      return;
    }

    if (this.Instruction.instructionType == ResIntructionType.ContinuousMarket) {
      this._resService.SaveInstruction(this.Instruction, null, null).subscribe(
        resp => this.Cancel()
      );
    }
    else {
      this._resService.SaveInstruction(this.Instruction, this.closeFileToUpload, this.coFileToUpload).subscribe(
        resp => this.Cancel()
      );
    }
  }

  public Cancel() {
    this._router.navigate(['res']);
  }

  DeleteInstance(instance: Array<any>, i: number) {
    instance.splice(i, 1);
  }

  onFileSelected(instance: string, event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (instance == 'closeImage') {
        this.closeFileToUpload = file;
        this.closeFileData = URL.createObjectURL(file);
      }
      else if (instance == 'coAssumptionsImage') {
        this.coFileToUpload = file;
        this.coFileData = URL.createObjectURL(file);
      }
    }
  }

  async pasteFromClipboard(instance: string) {
    try {
    // Request clipboard items
    const clipboardItems = await navigator.clipboard.read();

    for (const item of clipboardItems) {
      for (const type of item.types) {
        if (type.startsWith("image/")) {
          const blob = await item.getType(type);

          // Convert to data URL for preview
          const reader = new FileReader();
          reader.onload = () => {
            const dataUrl = reader.result as string;
            debugger;
            if (instance === 'closeImage') {
              this.closeFileData = dataUrl;
              this.closeFileToUpload = this.base64ToFile(dataUrl.split(',')[1], 'closeImage.png', 'image/png');
            } else if (instance === 'coAssumptionsImage') {
              this.coFileData = dataUrl;
              this.coFileToUpload = this.base64ToFile(dataUrl.split(',')[1], 'coAssumptionsImage.png', 'image/png');
            }
          };
          reader.readAsDataURL(blob);

          return; // stop after first image
        }
      }
    }

    alert("No image found in clipboard!");
  } catch (err) {
    console.error("Failed to read clipboard:", err);
    alert("Clipboard access requires HTTPS and permission.");
  }
  }

  DeleteFile(instance: any) {
    if (instance === 'closeImage') {
      this.closeFileToUpload = null;
    } else if (instance === 'coAssumptionsImage') {
      this.coFileToUpload = null;
    }
  }

  onStartDateChanged(event: any) {
    try {
      this.Instruction.issuedTo = new Date(this.Instruction.issuedFrom);
      this.Instruction.issuedTo.setDate(this.Instruction.issuedTo.getDate() + 1);
      this.Instruction.issuedTo = this.Instruction.issuedTo.toISOString().split('T')[0]
    }
    catch {
      this.Instruction.issuedTo = new Date().toISOString().split('T')[0];
    }
  }

  AddContinuousMarketData(continuousMarket: Array<any>) {
    continuousMarket.push({
      product: "",
      volume: 0,
      limitPrice: 0,
      direction: ""
    });
  }

  // Converts the image back to a file that can be uploaded in the new instruction when being copied
  private base64ToFile(base64: string, fileName: string, mimeType: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  }
}
